module.exports = __webpack_public_path__ + "img/fruit-melons-350x184.61adc127.jpg";